/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, PageRequestFromJSON, PageRequestToJSON, PlayerListEntryFromJSON, PlayerListEntryToJSON, } from './';
export function PagedResponseOfPlayerListEntryFromJSON(json) {
    return PagedResponseOfPlayerListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfPlayerListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(PlayerListEntryFromJSON)),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'page': !exists(json, 'page') ? undefined : json['page']
    };
}
export function PagedResponseOfPlayerListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'metaData': MetaDataToJSON(value.metaData),
        'nextPage': PageRequestToJSON(value.nextPage),
        'previousPage': PageRequestToJSON(value.previousPage),
        'totalElements': value.totalElements,
        'hasPrevious': value.hasPrevious,
        'numberOfElements': value.numberOfElements,
        'hasNext': value.hasNext,
        'entries': value.entries === undefined ? undefined : (value.entries.map(PlayerListEntryToJSON)),
        'size': value.size,
        'page': value.page
    };
}
